import styled from '@emotion/styled';
import {
  Button as _Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table as _Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { createElement, FC, ReactElement, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { createRewardListData, ModificationRequests, OfferPricingDetails } from '../../../utility/createRewardListData';
import Dialog from '../primitive/DialogWithPadding';

type Props = {
  offerPricingDetails: OfferPricingDetails;
  modificationRequests: ModificationRequests;
  expressDueDays: number;
  rewardEnabled: boolean;
  className?: string;
};

const CreationReward: FC<Props> = ({
  offerPricingDetails,
  modificationRequests,
  expressDueDays,
  rewardEnabled,
  className,
}) => {
  const [open, setOpen] = useState(false);

  if (rewardEnabled) {
    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const rewardList = createRewardListData(offerPricingDetails, modificationRequests);
    const rewardListItems: ReactElement<any>[] = [];
    let totalRewardAmount = 0;
    let rewardCurrency = 'jpy';
    let key = 0;
    rewardList.map((list) => {
      list.map((row) => {
        const quantity = row.quantity;
        totalRewardAmount += row.rewardAmount * quantity;
        rewardCurrency = row.rewardCurrency;
        rewardListItems.push(
          <TableRow key={key++}>
            <TableCell component="th" scope="row">
              <Typography variant="body2">
                {row.categoryName ? (
                  <FormattedMessage
                    id={`reward_dialog.category_name.${row.categoryName}`}
                    values={{ days: expressDueDays, num: quantity }}
                  />
                ) : null}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">
                {row.itemKey != null && row.itemKey != '' && row.itemName == null ? (
                  <FormattedMessage id={`reward_dialog.item_name.${row.itemKey}`} />
                ) : row.itemName != null ? (
                  row.itemName
                ) : (
                  <FormattedMessage id="reward_dialog.category_name.basic" />
                )}
              </Typography>
            </TableCell>
            <TableCellReward>
              <Typography align="right">
                <FormattedMessage id={`reward_dialog.reward_currency.${row.rewardCurrency.toLowerCase()}`} />{' '}
                {row.rewardAmount.toLocaleString()}
              </Typography>
            </TableCellReward>
            <TableCell>
              <Typography align="right">{quantity.toLocaleString()}</Typography>
            </TableCell>
            <TableCellReward>
              <Typography align="right">
                <FormattedMessage id={`reward_dialog.reward_currency.${row.rewardCurrency.toLowerCase()}`} />{' '}
                {(row.rewardAmount * quantity).toLocaleString()}
              </Typography>
            </TableCellReward>
          </TableRow>,
        );
      });
    });

    return (
      <div className={className}>
        <Button variant="outlined" color="default" size="small" onClick={handleClickOpen}>
          <Typography variant="button">
            <FormattedMessage id="creation.reward" />:{' '}
            <FormattedMessage id={`reward_dialog.reward_currency.${rewardCurrency.toLowerCase()}`} />{' '}
            {totalRewardAmount.toLocaleString()}
          </Typography>
        </Button>

        <Dialog open={open} onRequestClose={handleClose} maxWidth="md">
          <DialogContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="body2">
                      <FormattedMessage id="reward_dialog.table_header.category_name" />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      <FormattedMessage id="reward_dialog.table_header.item_name" />
                    </Typography>
                  </TableCell>
                  <TableCellReward>
                    <Typography variant="body2" align="center">
                      <FormattedMessage id="reward_dialog.table_header.reward" />
                    </Typography>
                  </TableCellReward>
                  <TableCell>
                    <Typography variant="body2" align="center">
                      <FormattedMessage id="reward_dialog.table_header.amount" />
                    </Typography>
                  </TableCell>
                  <TableCellReward>
                    <Typography variant="body2" align="center">
                      <FormattedMessage id="reward_dialog.table_header.reward_subtotal" />
                    </Typography>
                  </TableCellReward>
                </TableRow>
              </TableHead>
              <TableBody>{rewardListItems}</TableBody>
            </Table>
          </DialogContent>
          <DialogTitle>
            <Typography variant="subtitle1" align="right">
              <FormattedMessage id="reward_dialog.reward_total" />:{' '}
              <FormattedMessage id={`reward_dialog.reward_currency.${rewardCurrency.toLowerCase()}`} />{' '}
              {totalRewardAmount.toLocaleString()}
            </Typography>
          </DialogTitle>
          <DialogActions>
            <Button color="default" onClick={handleClose}>
              <FormattedMessage id="reward_dialog.close_button" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return <div className={className} />;
  }
};

const Button = styled(_Button)({
  minWidth: 130,
});

const Table = styled(_Table)({
  width: '100%',
});

const TableCellReward = styled(TableCell)({
  minWidth: 160,
});

export default CreationReward;
